module.exports = __webpack_public_path__ + "static/media/big-neon-gif-4.8608fee3.gif";